<template>
    <div class="promotions container">
        <content-header title="Специальные программы"/>

        <div class="promotions-list">
            <div class="promotions-item" :key="offer.id" v-for="offer in specialPrograms">
                <router-link tag="div" class="promotions__image"
                             :to="{name: 'specialPrograms', params: {title: offer.slug}}">
                    <img :src="offer.photo ? offer.photo.crop : ''" :alt="offer.title">
                </router-link>
                <router-link tag="div" :to="{name: 'specialPrograms', params: {title: offer.slug}}"
                             class="promotions__link">
                    {{ offer.title }}
                </router-link>

                <div v-if="offer.is_finished" class="promotions__sub-title">АКЦИЯ ЗАВЕРШЕНА</div>
                <div v-html="offer.short_description" :class="{'offer-end': offer.is_finished }"
                     class="promotions__desc"/>

            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import {mapActions, mapGetters} from "vuex";

export default {
    components: {
        ContentHeader,
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters(["specialPrograms"]),
    },
    methods: {
        ...mapActions(["fetchSpecialPrograms"])
    },
    mounted() {
        this.fetchSpecialPrograms({})
    }
}

</script>

<style lang="scss" scoped>
.container {
    font-family: Arial, sans-serif;
    font-size: 13px;
}

.promotions {

    .promotions-list {
        margin-top: 20px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        grid-gap: 20px;
    }

    .promotions-list-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 40px 0;

        @media screen and (max-width: 570px) {
            flex-direction: column;

            .promotions-list-dropdown {
                margin-bottom: 20px;
            }
        }

        .promotions-header-check {
            font: normal 16px/12px Arial, sans-serif;
            color: #2E2E2E;
            cursor: pointer;

            span {
                padding-left: 10px;
            }

            input[type="checkbox"] {
                padding-top: 5px;
            }
        }
    }

    .promotions__desc {
        text-align: left;
    }

    .promotions-item {
        font-size: 13px;
    }

    &__image {
        cursor: pointer;

        img {
            width: 100%;
        }
    }

    &__link {
        width: fit-content;
        margin: 10px auto;
        font-weight: bold;
        color: #006688;
        cursor: pointer;
        //border-bottom: 1px dotted #006688;
    }

    &__sub-title {
        color: black;
        margin: 15px 0;
        font-weight: bold;
    }

    .offer-end {
        text-decoration: line-through;
    }
}
</style>

<style lang="scss">
.promotions-list-header {
    .promotions-list-dropdown {
        min-width: 255px;
        height: 43px;
        background: #FFFFFF;
        border-radius: 4px;
        display: flex;
        align-items: center;

        .output-container {
            border: unset;
        }

        .output-container h1 {
            font: normal 16px/12px Arial, sans-serif;
            color: #2E2E2E;
            max-width: unset;
            width: 100% !important;
            padding-right: 10px;
            height: 20px;
            min-width: 255px;
        }

        .drop-down-wrapper.open {
            width: 100%;
            border: unset;
        }

        .drop-down-wrapper li {
            display: flex;
            align-items: center;
            height: 40px;
        }
    }
}
</style>